import { Button, Col, Container, FloatingLabel, Form, Row, Alert } from "react-bootstrap";
import emailjs from '@emailjs/browser';
import Select from 'react-select';
import { getCollection } from "../services/firestoreGetCollection";
import { useEffect, useState, useCallback } from "react";
import ScaleLoader from "react-spinners/ClipLoader";
import { useLoadingContext } from "../context/LoadingContext";
import { React } from 'react';

export function SingUp() {
    const [lessen, setLessen] = useState({});
    const [groupSelection, setGroupSelection] = useState([]);

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [rrNumber, setRrNumber] = useState("");
    const [street, setStreet] = useState("");
    const [houseNumber, setHouseNumber] = useState("");
    const [busNumber, setBusNumber] = useState("");
    const [place, setPlace] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [birthday, setBirthDay] = useState("");
    const [chosenGroups, setChosenGroups] = useState([]);
    const [parentPhone, setParentPhone] = useState("");
    const [parentEmail, setParentEmail] = useState("");
    const [phoneMember, setPhoneMember] = useState("");
    const [emailMember, setEmailMember] = useState("");
    const { loading } = useLoadingContext();
    const { setLoading } = useLoadingContext();
    const [selectedOption, setSelectedOption] = useState("1");
    const [enrollmentPeriod, setEnrollmentPeriod] = useState("full"); // "full" or "half"

    const [showAlert, setShowAlert] = useState(false);
    const [showError, setShowError] = useState(false);

    const createOptions = useCallback(() => {
        let options = []
        for (const [, value] of Object.entries(lessen)) {
            for (const groep of value.groepen) {
                options.push({ name: groep.groepNaam, leeftijd: groep.leeftijd })
            }
        }
        let selectionOptions = options.filter(groep => groep.name !== "Fitness");
        selectionOptions.push(
            { name: "Fitness Dinsdag", leeftijd: "Vanaf 16 jaar" }, 
            { name: "Fitness Woensdag", leeftijd: "Vanaf 16 jaar" }, 
            { name: "Fitness Donderdag", leeftijd: "Vanaf 16 jaar" }
        );
        let formattedSelections = [];

        for (const group of selectionOptions) {
            formattedSelections.push({ 
                value: group.name, 
                label: `${group.name} | ${group.leeftijd}`,
                category: group.name.includes('Fitness') ? 'Fitness' : 'Dans'
            });
        }

        setGroupSelection(formattedSelections);
    }, [lessen]);

    useEffect(() => {
        async function getLessen() {
            const data = await getCollection("classes");
            console.log(data);
            return setLessen(data);
        }

        getLessen()
    }, [])

    useEffect(() => {
        createOptions()
    }, [createOptions])

    function calculateCost() {
        console.log(selectedOption)
        let placeHolderCost = 0;
        let placeHolderGroups = chosenGroups;
        let allFitness = false;
        let onlyOne = false
        setLoading(true);
        setShowAlert(false);
        setShowError(false);

        // Check if all fitness classes are selected
        if (placeHolderGroups.includes("Fitness Dinsdag") && placeHolderGroups.includes("Fitness Woensdag") && placeHolderGroups.includes("Fitness Donderdag")) {
            placeHolderCost = enrollmentPeriod === "full" ? 240 : 120; // Full year: 235, Half year: 120
            placeHolderGroups = placeHolderGroups.filter(word => !word.includes("Fitness"))
            console.log(placeHolderGroups);
            allFitness = true;
        }

        // Calculate base cost for first group
        if (placeHolderGroups.length === 1 && allFitness === false) {
            placeHolderCost = enrollmentPeriod === "full" ? 150 : 85; // Full year: 150, Half year: 85
            onlyOne = true
        } else {
            if (onlyOne === false && allFitness === false) {
                placeHolderCost = enrollmentPeriod === "full" ? 150 : 85; // Base cost
                placeHolderCost += 90 * (placeHolderGroups.length - 1); // Extra groups now cost 90 euros
            } else {
                if (placeHolderGroups.length >= 1 && allFitness === false) {
                    placeHolderCost = enrollmentPeriod === "full" ? 150 : 85; // Base cost
                    placeHolderCost += 90 * (placeHolderGroups.length - 1); // Extra groups now cost 90 euros
                } else {
                    placeHolderCost += 90 * (placeHolderGroups.length); // Extra groups cost 90 euros
                }
            }
        }

        // Apply family discounts
        if(selectedOption === "2"){
            placeHolderCost = placeHolderCost - 10
        }
        if(selectedOption === "3"){
            placeHolderCost = placeHolderCost - 30
        }
        console.log(placeHolderCost);

        submitEmail(placeHolderCost);
    }

    function submitEmail(totalCost) {
        setLoading(true);
        let aplliedDiscount = 0;
        let Korting = "Geen"
        if(selectedOption === "2"){
            Korting = "10 €"
            aplliedDiscount = 10;
        }
        if(selectedOption === "3"){
            Korting = "30 €"
            aplliedDiscount = 30
        }
        
        const formInformation = {
            name: name,
            surname: surname,
            rrNumber: rrNumber,
            street: street,
            houseNumber: houseNumber,
            busNumber: busNumber,
            postalCode: postalCode,
            place: place,
            birthday: birthday,
            parentPhone: parentPhone,
            parentEmail: parentEmail,
            phoneMember: phoneMember,
            emailMember: emailMember,
            chosenGroups: chosenGroups,
            enrollmentPeriod: enrollmentPeriod === "full" ? "Volledig jaar" : "Half jaar",
            korting : Korting,
            totalCost: totalCost,
            insurancePremium: 15,
            preDiscount : aplliedDiscount + totalCost
        }

        emailjs.send('service_1j5khlc', 'template_nfeyc74', formInformation, 'user_PPpSpfPeJ2bq8l4t9Al08')
            .then((result) => {
                console.log(result.text);
                setLoading(false);
                setShowAlert(true);
                clearForm();
            }, (error) => {
                console.log(error.text);
                setLoading(false);
                setShowError(true);
            })
    }

    function sendMail(e) {
        e.preventDefault();
        calculateCost()
    }

    function clearForm() {
        document.getElementById("subscribeform").reset();
        setName("");
        setSurname("");
        setRrNumber("");
        setStreet("");
        setHouseNumber("");
        setBusNumber("");
        setPlace("");
        setPostalCode("");
        setBirthDay("");
        setChosenGroups([]);
        setParentPhone("");
        setParentEmail("");
        setPhoneMember("");
        setEmailMember("");
        setSelectedOption("1");
        setEnrollmentPeriod("full");
    }

    function handleChange(option) {
        let placeholderArray = []
        for (const group of option) {
            placeholderArray.push(group.value);
        }
        console.log(placeholderArray);
        setChosenGroups(placeholderArray);
        return;
    }

    const handleChangeRadio = e => {
        const target = e.target;
        if (target.checked) {
          setSelectedOption(e.target.value)
        }
    };

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            border: '2px solid #e9ecef',
            borderRadius: 'var(--radius-md)',
            padding: '0.5rem 0.25rem',
            minHeight: '56px',
            borderColor: state.isFocused ? 'var(--primary-purple)' : '#e9ecef',
            boxShadow: state.isFocused ? '0 0 0 3px var(--primary-purple-light)' : 'none',
            '&:hover': {
                borderColor: 'var(--primary-purple)'
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: 'var(--primary-purple-light)',
            borderRadius: 'var(--radius-sm)'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: 'var(--primary-purple)',
            fontWeight: '500'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: 'var(--primary-purple)',
            '&:hover': {
                backgroundColor: 'var(--accent-gold)',
                color: 'white'
            }
        })
    };

    return (
        <Container id="signup" fluid className="bg-animated-gradient bg-geometric-pattern skewedLeftTopContent section-padding">
            <div className="skewedBothContent">
                {loading && (
                    <div className="loader">
                        <ScaleLoader color={"var(--accent-gold)"} loading={loading} size={25} />
                    </div>
                )}

                <div className="container-modern">
                    <div className="text-center mb-5 fade-in">
                        <h2 className="font-type heading-lg text-light hoofding">Inschrijvingen 2025-2026</h2>
                        <p className="text-lg text-light opacity-75">
                            Wordt lid van onze dansschool en ontdek de magie van bewegen op muziek
                        </p>
                    </div>

                    {/* Pricing Information Cards */}
                    <div className="row g-4 mb-5">
                        <div className="col-lg-6">
                            <div className="card-modern slide-in-left">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="icon-wrapper me-3">
                                        <i className="fas fa-music"></i>
                                    </div>
                                    <h4 className="card-modern-title mb-0">Dansers</h4>
                                </div>
                                <p className="card-modern-body">
                                    Het inschrijvingsgeld bedraagt voor een heel jaar <strong>150 euro</strong>. 
                                    Voor een half jaar betaal je <strong>85 euro</strong>. 
                                    Als je in meerdere groepen danst betaal je per extra groep <strong>90 euro</strong>.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card-modern slide-in-right">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="icon-wrapper me-3">
                                        <i className="fas fa-dumbbell"></i>
                                    </div>
                                    <h4 className="card-modern-title mb-0">Fitness</h4>
                                </div>
                                <p className="card-modern-body">
                                    Het inschrijvingsgeld bedraagt <strong>150 euro voor 1 lesuur</strong> (volledig jaar). 
                                    Voor een half jaar <strong>85 euro</strong>. 
                                    Voor het bedrag van <strong>240 euro</strong> kan je alle lessen (3) volgen voor het volledige jaar.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Important Notice */}
                    <div className="alert-modern alert-success-modern mb-5 slide-in-left">
                        <div className="d-flex align-items-start">
                            <i className="fas fa-info-circle me-3 mt-1"></i>
                            <div>
                                <h6 className="mb-2">Belangrijke informatie over verzekering</h6>
                                <p className="mb-2">
                                    <strong>Bij betaling vóór 19 september 2025:</strong> Verzekering inbegrepen bij het lidgeld.
                                </p>
                                <p className="mb-0">
                                    <strong>Bij betaling na 19 september:</strong> Extra bedrag van 15 euro per lid voor verzekering.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Registration Form */}
                    <div className="card-modern slide-in-right">
                        <div className="card-modern-header">
                            <h3 className="card-modern-title">Inschrijvingsformulier</h3>
                            <p className="text-muted mb-0">
                                Na het invullen van dit formulier zal u een e-mail ontvangen met verdere instructies.
                            </p>
                        </div>

                        <Form id="subscribeform" onSubmit={sendMail}>
                            {/* Personal Information */}
                            <div className="mb-4">
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-user me-2 text-primary"></i>
                                    Persoonlijke gegevens
                                </h5>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Naam *</label>
                                            <input 
                                                required 
                                                name="from_lastName" 
                                                type="text" 
                                                placeholder="Voer uw naam in"
                                                className="form-control-modern"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Voornaam *</label>
                                            <input 
                                                required 
                                                name="from_firstName" 
                                                type="text" 
                                                placeholder="Voer uw voornaam in"
                                                className="form-control-modern"
                                                value={surname}
                                                onChange={(e) => setSurname(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Insurance Information */}
                            <div className="card-glass mb-4 p-4" style={{ background: 'var(--primary-purple-light)' }}>
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-shield-alt me-2"></i>
                                    Informatie vereist voor de verzekering
                                </h5>
                                
                                <div className="form-floating-modern mb-3">
                                    <label className="form-label-modern">Rijksregisternummer *</label>
                                    <input 
                                        required 
                                        name="rijksregisternummer" 
                                        type="text" 
                                        placeholder="00.00.00-000.00"
                                        className="form-control-modern"
                                        value={rrNumber}
                                        onChange={(e) => setRrNumber(e.target.value)}
                                    />
                                </div>

                                <Row className="g-3 mb-3">
                                    <Col lg={8}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Straatnaam *</label>
                                            <input 
                                                required 
                                                name="straatnaam" 
                                                type="text" 
                                                placeholder="Voer straatnaam in"
                                                className="form-control-modern"
                                                value={street}
                                                onChange={(e) => setStreet(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={2}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Nr. *</label>
                                            <input 
                                                required 
                                                name="huisnummer" 
                                                type="text" 
                                                placeholder="123"
                                                className="form-control-modern"
                                                value={houseNumber}
                                                onChange={(e) => setHouseNumber(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={2}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Bus</label>
                                            <input 
                                                name="busnummer" 
                                                type="text" 
                                                placeholder="A"
                                                className="form-control-modern"
                                                value={busNumber}
                                                onChange={(e) => setBusNumber(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="g-3 mb-3">
                                    <Col md={4}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Postcode *</label>
                                            <input 
                                                required 
                                                name="postalCode" 
                                                type="text" 
                                                placeholder="0000"
                                                className="form-control-modern"
                                                value={postalCode}
                                                onChange={(e) => setPostalCode(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={8}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Plaats *</label>
                                            <input 
                                                required 
                                                name="plaats" 
                                                type="text" 
                                                placeholder="Voer plaatsnaam in"
                                                className="form-control-modern"
                                                value={place}
                                                onChange={(e) => setPlace(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <div className="form-floating-modern">
                                    <label className="form-label-modern">Geboortedatum *</label>
                                    <input 
                                        required 
                                        name="geboortedatum" 
                                        type="date" 
                                        className="form-control-modern"
                                        value={birthday}
                                        onChange={(e) => setBirthDay(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* Class Selection */}
                            <div className="mb-4">
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-users me-2"></i>
                                    Gewenste groepen
                                </h5>
                                <Select 
                                    isMulti 
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    options={groupSelection} 
                                    onChange={(option) => handleChange(option)}
                                    placeholder="Selecteer de gewenste groepen..."
                                    styles={customSelectStyles}
                                    noOptionsMessage={() => "Geen groepen gevonden"}
                                />
                            </div>

                            {/* Enrollment Period Selection */}
                            <div className="mb-4">
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-calendar-alt me-2"></i>
                                    Inschrijvingsperiode
                                </h5>
                                <p className="text-muted mb-3">Kies voor welke periode je je wilt inschrijven</p>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="card-modern p-3 cursor-pointer h-100 hover-lift">
                                            <input
                                                type="radio"
                                                name="enrollment-period"
                                                value="full"
                                                checked={enrollmentPeriod === "full"}
                                                onChange={(e) => setEnrollmentPeriod(e.target.value)}
                                                className="form-check-input me-2"
                                            />
                                            <strong>Volledig jaar</strong>
                                            <div className="text-muted small">September 2025 - Juni 2026</div>
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="card-modern p-3 cursor-pointer h-100 hover-lift">
                                            <input
                                                type="radio"
                                                name="enrollment-period"
                                                value="half"
                                                checked={enrollmentPeriod === "half"}
                                                onChange={(e) => setEnrollmentPeriod(e.target.value)}
                                                className="form-check-input me-2"
                                            />
                                            <strong>Half jaar</strong>
                                            <div className="text-muted small">September 2025 - Januari 2026</div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Family Member Discount */}
                            <div className="mb-4">
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-percentage me-2"></i>
                                    Familiekorting
                                </h5>
                                <p className="text-muted mb-3">Voor welk gezinslid is deze inschrijving? (Korting vanaf het tweede)</p>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label className="card-modern p-3 cursor-pointer h-100 hover-lift">
                                            <input
                                                type="radio"
                                                name="family-member"
                                                value="1"
                                                checked={selectedOption === "1"}
                                                onChange={handleChangeRadio}
                                                className="form-check-input me-2"
                                            />
                                            <strong>Eerste lid</strong>
                                            <div className="text-muted small">Volledige prijs</div>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="card-modern p-3 cursor-pointer h-100 hover-lift">
                                            <input
                                                type="radio"
                                                name="family-member"
                                                value="2"
                                                checked={selectedOption === "2"}
                                                onChange={handleChangeRadio}
                                                className="form-check-input me-2"
                                            />
                                            <strong>Tweede lid</strong>
                                            <div className="text-success small">10€ korting</div>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="card-modern p-3 cursor-pointer h-100 hover-lift">
                                            <input
                                                type="radio"
                                                name="family-member"
                                                value="3"
                                                checked={selectedOption === "3"}
                                                onChange={handleChangeRadio}
                                                className="form-check-input me-2"
                                            />
                                            <strong>Derde lid</strong>
                                            <div className="text-success small">30€ korting</div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Information */}
                            <div className="mb-4">
                                <h5 className="mb-3 d-flex align-items-center">
                                    <i className="fas fa-phone me-2"></i>
                                    Contactgegevens
                                </h5>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Telefoonnummer Ouder *</label>
                                            <input 
                                                required 
                                                name="primaryContact" 
                                                type="tel" 
                                                placeholder="+32 123 45 67 89"
                                                className="form-control-modern"
                                                value={parentPhone}
                                                onChange={(e) => setParentPhone(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Email Ouder *</label>
                                            <input 
                                                required 
                                                name="emailOuder" 
                                                type="email" 
                                                placeholder="ouder@email.be"
                                                className="form-control-modern"
                                                value={parentEmail}
                                                onChange={(e) => setParentEmail(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                
                                <Row className="g-3 mt-2">
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Telefoonnummer lid</label>
                                            <input 
                                                name="phoneNumberMember" 
                                                type="tel" 
                                                placeholder="+32 123 45 67 89"
                                                className="form-control-modern"
                                                value={phoneMember}
                                                onChange={(e) => setPhoneMember(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-floating-modern">
                                            <label className="form-label-modern">Email lid</label>
                                            <input 
                                                name="emailMember" 
                                                type="email" 
                                                placeholder="lid@email.be"
                                                className="form-control-modern"
                                                value={emailMember}
                                                onChange={(e) => setEmailMember(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Submit Button */}
                            <div className="text-center mb-4">
                                <button type="submit" className="btn-primary-modern btn-lg">
                                    <i className="fas fa-user-plus me-2"></i>
                                    Inschrijving Versturen
                                </button>
                            </div>

                            {/* Alerts */}
                            {showAlert && (
                                <div className="alert-modern alert-success-modern">
                                    <h6 className="mb-0">
                                        <i className="fas fa-check-circle me-2"></i>
                                        Bedankt, jouw inschrijving is ontvangen. Je ontvangt verdere instructies via mail.
                                    </h6>
                                </div>
                            )}
                            
                            {showError && (
                                <div className="alert-modern alert-danger-modern">
                                    <h6 className="mb-0">
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        Er ging iets mis met de inschrijving, gelieve telefonisch contact op te nemen
                                    </h6>
                                </div>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        </Container>
    );
}